import { render, staticRenderFns } from "./TabelaNotaDePesagem.vue?vue&type=template&id=0abbe0aa&lang=pug"
import script from "./TabelaNotaDePesagem.vue?vue&type=script&lang=js"
export * from "./TabelaNotaDePesagem.vue?vue&type=script&lang=js"
import style0 from "./TabelaNotaDePesagem.vue?vue&type=style&index=0&id=0abbe0aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports